module.exports = __webpack_public_path__ + "static/media/TempCal32.ae9ead23.jpg";